export const FLAG_ZALBE = 'FLAG_ZALBE';
export const FLAG_REZULTATI_SKOLA_G = 'FLAG_REZULTATI_SKOLA_G';
export const FLAG_REZULTATI = 'FLAG_REZULTATI';
export const FLAG_FINALE = 'FLAG_FINALE';
export const FLAG_ZABRANA = 'FLAG_ZABRANA';
export const FLAG_AUTOMATSKO_POVEZIVANJE = 'FLAG_AUTOMATSKO_POVEZIVANJE';

export const modeDescriptions = {
  FLAG_ZABRANA: 'Završeno prijavljivanje učenika',
  FLAG_ZALBE: 'Dozvoljeno podnošenje žalbi',
  FLAG_REZULTATI_SKOLA_G: 'Rezultati Škola',
  FLAG_REZULTATI: 'Konačni rezultati',
  FLAG_FINALE: 'Finale'
};
